module.exports = __webpack_public_path__ + "assets/130eafc23a987a6cf560c9b69af84818.woff";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-all-300-normal.woff
// module id = 273
// module chunks = 121